import { render, staticRenderFns } from "./commondityLabel.vue?vue&type=template&id=40417c78&scoped=true&"
import script from "./commondityLabel.vue?vue&type=script&lang=js&"
export * from "./commondityLabel.vue?vue&type=script&lang=js&"
import style0 from "./commondityLabel.vue?vue&type=style&index=0&id=40417c78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40417c78",
  null
  
)

export default component.exports